import "./Process.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import TheEcoShineProcess from "./sections/TheEcoShineProcess";
import RobotAgentFaq from "./sections/RobotAgentFaq";
import Footer from "@/reusable_sections/Footer";
export default function ProcessPage() {
  return <div>
      <AutoMotiGalvene />
      <TheEcoShineProcess />
      <RobotAgentFaq />
      <Footer />
    </div>;
}